import React, { useEffect } from "react";
import Header from "../../components/layout/Header";
import Footer from "../../components/layout/Footer";
import Hero from "../../components/About/hero/Hero";
import { BRAND } from "../../data/brand";

function Terms() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />
      <Hero heading="Terms of Service" />
      <div className="layout-container layout-container--narrow layout-section prose">
        <p className="text-gray-500">Last updated: March 2026</p>

        <h2 id="heading-md" className="mt-8">1. Agreement to Terms</h2>
        <p className="text-gray-700 mt-2">
          By accessing or using the services of {BRAND.name}, you agree to be bound
          by these Terms of Service. If you do not agree, please do not use our services.
        </p>

        <h2 id="heading-md" className="mt-8">2. Services Description</h2>
        <p className="text-gray-700 mt-2">
          {BRAND.name} provides study-abroad consultancy services including university
          admissions assistance, visa guidance, scholarship applications, SOP writing,
          accommodation booking, air ticket booking, and international SIM card services.
        </p>

        <h2 id="heading-md" className="mt-8">3. Payment Terms</h2>
        <p className="text-gray-700 mt-2">
          All fees are quoted in Indian Rupees (INR) unless otherwise stated. Payment is
          required before service delivery unless an installment plan has been agreed upon.
          Payments are processed securely through Razorpay.
        </p>

        <h2 id="heading-md" className="mt-8">4. Refund Policy</h2>
        <p className="text-gray-700 mt-2">
          Refund requests must be submitted within 7 days of payment. Service fees for
          work already completed are non-refundable. Unused package components may be
          eligible for partial refunds at our discretion. Visa and admission outcomes
          are not guaranteed and do not qualify for automatic refunds.
        </p>

        <h2 id="heading-md" className="mt-8">5. Client Responsibilities</h2>
        <p className="text-gray-700 mt-2">
          Clients must provide accurate and complete information. {BRAND.name} is not
          responsible for delays or rejections caused by false, incomplete, or misleading
          information provided by the client.
        </p>

        <h2 id="heading-md" className="mt-8">6. Limitation of Liability</h2>
        <p className="text-gray-700 mt-2">
          {BRAND.name} provides guidance and assistance but cannot guarantee university
          admission, visa approval, or scholarship awards. Our liability is limited to
          the amount paid for the specific service in question.
        </p>

        <h2 id="heading-md" className="mt-8">7. Contact</h2>
        <p className="text-gray-700 mt-2">
          For questions about these terms, contact us at {BRAND.email} or {BRAND.phone}.
        </p>
      </div>
      <Footer />
    </>
  );
}

export default Terms;
